import type { LucideIcon } from 'lucide-react';
import { BookOpen, FileText, ListChecks, StickyNote } from 'lucide-react';

/**
 * Icon per document display type — the one mapping shared by the Documents
 * index rows, the file-tree panel, and the citations UI.
 */
export function docTypeIcon(type: string | null): LucideIcon {
  switch (type) {
    case 'journal':
      return BookOpen;
    case 'list':
      return ListChecks;
    case 'note':
      return StickyNote;
    default:
      return FileText;
  }
}
